import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators';
import { DataScopesEnum } from '../../shared/enums/index';
import { IServerSettings, IServiceError } from '../models/index';
import { AuthenticationService } from './authentication.service';
import { SettingsService } from './settings.service';
import { StorageManagerService } from './storage-manager.service';

@Injectable({
  providedIn: 'root'
})
export class ExportDataService {

  dataScopeEnum = DataScopesEnum;
  private action: string;
  private apiGatewayUrl: string;
  private commonApiGatewayUrl: string;
  private settings: IServerSettings;

  constructor(private http: HttpClient, private settingsService: SettingsService, private authService: AuthenticationService, private storageManagerService: StorageManagerService) { }

  getAttributesMock() {
    return this.http.get('../assets/mock/attributes-mock.json');
  }

  getTemplatesMock() {
    return this.http.get('../assets/mock/templates-mock.json');
  }

  getExportsMock() {
    return this.http.get('../assets/mock/generated-files-mock.json');
  }

  saveExportTemplate(exportTemplate) {
    var fields = exportTemplate.exportDataTemplate.deviceAttributes.find(a => a.name === 'DEVICE_KEY_IDENTIFICATION')?.fields;
    if (fields) {
      fields.find(a => a.name === 'UDI_DEVICE_IDENTIFIER').caption = fields.find(a => a.name === 'UDI_DEVICE_IDENTIFIER').caption.replace('/EUDAMED ID', '');
      fields.find(a => a.name === 'UDI_DEVICE_IDENTIFIER_ISSUING_AGENCY').caption = fields.find(a => a.name === 'UDI_DEVICE_IDENTIFIER_ISSUING_AGENCY').caption.replace('/EUDAMED ID Issuing Agency', '');
    }
    fields = exportTemplate.exportDataTemplate.deviceAttributes.find(a => a.name === 'BASIC_UDI_DI_REFERENCE')?.fields;
    if (fields) {
      fields.find(a => a.name === 'BUDI_DEVICE_IDENTIFIER').caption = fields.find(a => a.name === 'BUDI_DEVICE_IDENTIFIER').caption.replace('/EUDAMED DI', '');
      fields.find(a => a.name === 'BUDI_DEVICE_IDENTIFIER_ISSUING_AGENCY').caption = fields.find(a => a.name === 'BUDI_DEVICE_IDENTIFIER_ISSUING_AGENCY').caption.replace('/EUDAMED DI Issuing Agency', '');
    }
    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/ExportData/SaveTemplate`;

    const headers = this.authService.setHeader();

    return this.http.post(`${this.apiGatewayUrl}/${this.action}`, exportTemplate, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  deleteExportTemplate(templateId) {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/ExportData/DeleteTemplate`;

    const headers = this.authService.setHeader();

    return this.http.post(`${this.apiGatewayUrl}/${this.action}`, { exportTemplateId: templateId }, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  runExportTemplate(templateId) {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/ExportData/RunTemplate`;

    const headers = this.authService.setHeader();

    return this.http.post(`${this.apiGatewayUrl}/${this.action}`, { exportTemplateId: templateId }, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  getTasks() {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/ExportData/GetTasks`;

    const headers = this.authService.setHeader(false, true);

    return this.http.get<any>(`${this.apiGatewayUrl}/${this.action}`, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }


  getTemplateAttributes() {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/ExportData/GetTemplateAttributes`;

    const headers = this.authService.setHeader(false, true);

    return this.http.get<any>(`${this.apiGatewayUrl}/${this.action}`, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  getTemplatesList() {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/ExportData/GetTemplates`;

    const headers = this.authService.setHeader(false, true);

    return this.http.get<any>(`${this.apiGatewayUrl}/${this.action}`, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  getExportFile(fileName, directoryPath) {

    this.settings = this.settingsService.getSettings();
    this.commonApiGatewayUrl = this.settings.CommonApiGatewayUrl;
    this.action = `fss/v1/FileStorage`;

    const storage = 'AzureBlob';
    const container = 'ssmd';

    const queryString = `?storage=${storage}&containerName=${container}&directoryPath=${directoryPath}&fileName=${fileName}`;

    const headers = this.authService.setHeader();

    return this.http.get<any>(`${this.commonApiGatewayUrl}/${this.action}${queryString}`, { responseType: 'blob' as 'json', headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  private handleHttpError(error: HttpErrorResponse): Observable<IServiceError> {

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      const dataError = new IServiceError();
      dataError.errorNumber = error.error ? error.error.number : '';
      dataError.message = error.message;
      dataError.friendlyMessage = error.status ? `Http call failed with status ${error.status}` : `Http call failed`;
      dataError.errorMessage = error.error ? error.error.message : '';
      dataError.errorStatus = error.status;
      dataError.url = error.url;

      // return an observable of an IServiceError object with a user friendly error message
      return of(dataError);
    }
  }
}
